import { render, staticRenderFns } from "./LegajoForm.vue?vue&type=template&id=01c4f90a"
import script from "./LegajoForm.vue?vue&type=script&lang=js"
export * from "./LegajoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01c4f90a')) {
      api.createRecord('01c4f90a', component.options)
    } else {
      api.reload('01c4f90a', component.options)
    }
    module.hot.accept("./LegajoForm.vue?vue&type=template&id=01c4f90a", function () {
      api.rerender('01c4f90a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Legajos/LegajoForm.vue"
export default component.exports